// global sync properties
const BPM = 120;
const ROWS_PER_BEAT = 2;
const ROW_RATE = BPM / 60 * ROWS_PER_BEAT;
const DEMO_LENGTH = 384;

export {
  BPM,
  ROWS_PER_BEAT,
  ROW_RATE,
  DEMO_LENGTH
};
